//Todo: a lot of these icons are links. Maybe it would be helpful to have my own local version (one benefit would be smaller sizes for faster loading)

export const languages = [{
  name : "C#",
  link : "https://docs.microsoft.com/en-us/dotnet/csharp/",
  icon : "https://upload.wikimedia.org/wikipedia/commons/b/bd/Logo_C_sharp.svg",
},
{
  name : "Python",
  link : "https://www.python.org",
  icon : "https://images.icon-icons.com/112/PNG/512/python_18894.png",
},
{
  name : "Javascript",
  link : "https://www.javascript.com/",
  icon : "https://img.icons8.com/color/512/javascript.png",
},
{
  name : "XAML",
  link : "https://learn.microsoft.com/en-us/dotnet/desktop/wpf/xaml",
  icon : "https://user-images.githubusercontent.com/7389110/76443001-aa91c180-63b9-11ea-99c1-2ef5362479ce.png",
}];

export const technologies = [{
  name : "Avalonia",
  link : "http://avaloniaui.net/",
  icon : "https://avatars.githubusercontent.com/u/58937344?s=400&v=4",
},
{
  name : "Visual Studio",
  link : "https://visualstudio.microsoft.com/",
  icon : "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Visual_Studio_Icon_2019.svg/1024px-Visual_Studio_Icon_2019.svg.png",
},
{
  name : "Google Apps Script",
  link : "https://developers.google.com/apps-script",
  icon : "https://static.wikia.nocookie.net/logopedia/images/0/0b/Google_Apps_Script_2013.png",
},
{
  name : "React",
  link : "https://react.dev/",
  icon : "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
},
{
  name : "Node.js",
  link : "https://nodejs.org",
  icon : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6bebC_d4eWwJ-x9ntqDuT94TvOgumSBVWHg&s",
},
{
  name : "AWS",
  link : "https://aws.amazon.com",
  icon : "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/AWS_Simple_Icons_AWS_Cloud.svg/1200px-AWS_Simple_Icons_AWS_Cloud.svg.png",
}];

//Other projects I could list:
// - React websites (Readdit, Tea Time, )
// - Clockwork
// - OctoPrint-Webhooks
// - YouTubeSubscriptionDownloader?
// - Gantt Chart?
// - WatchFace?
// - picroft (even though it's not active anymore, the 'mute button' project would show that I have hardware skills as well)
// - Chrome extensions (TrelloBugFeatureColors - though I don't know if it still works)
// - APCAlert?
// - 
//For some of these, they're not a great show of skill, but they might be worth adding just for more listings

//I could also add non-tech projects (eg 3D printing stuff, plant stuff, etc). As long as I have something to show.

//I could also talk about things on my HomeServer - but all that stuff is private

export const projects = [{
  name : "Bulk Edit Calendar Events",
  description : "A cross-platform desktop program for editing Google Calendar events in bulk",
  users : "~25,000",
  icon : "https://bulkeditcalendarevents.com/images/screenshots/main.png",
  website : "https://bulkeditcalendarevents.com",
  type: 'Desktop',
  languages : [
    "C#",
    "XAML",
  ],
  technologies : [
    "Avalonia",
    "Visual Studio",
  ],
  //Maybe keywords? Like 'desktop, Windows, macOS, customer-support, async, API, etc'
},
{
  name : "GAS-ICS-Sync",
  description : "A script for syncing ics/ical calendars to Google Calendar faster than the 12 hour cadence provided natively by Google Calendar",
  users : "1,200 stars on GitHub, probably 5-10x that many users",
  icon : "https://derekantrican.com/images/projects/gas-ics-sync.png",
  github : "https://github.com/derekantrican/GAS-ICS-Sync",
  type: 'Script',
  languages : [
    "Javascript",
  ],
  technologies : [
    "Google Apps Script",
  ],
},
{
  name : "MountainProjectBot",
  description : "An HTML scraper and reddit bot to link MountainProject.com and various climbing subreddits, replying automatically to posts with climbing information",
  icon : "https://derekantrican.com/images/projects/reddit_bot.png",
  github : "https://github.com/derekantrican/MountainProject",
  type: 'Bot',
  languages : [
    "C#",
  ],
  technologies : [
    "Visual Studio",
  ],
},
{
  name : "Tea Time",
  description : `A full React-based website for our weekly community group we host in our home. This was built to easily explain the concept, list partner groups (that might
  be geographically closer), and handle sign-ups.`,
  icon : "https://i.imgur.com/EXPba7o.png",
  website: "https://tea-time.social",
  github : "https://github.com/derekantrican/TeaTime",
  type: 'Website',
  languages : [
    "Javascript",
  ],
  technologies : [
    "React",
  ],
},
{
  name : "Subarr",
  description : 'A full-stack app using Node.js, express.js, & React to poll for YouTube videos (via RSS feeds) and take action (alert, download, etc)',
  icon: 'https://i.imgur.com/CymGLdK.png',
  github: 'https://github.com/derekantrican/subarr',
  type: 'Website',
  languages: [
    'Javascript',
  ],
  technologies: [
    'Node.js',
    'React',
  ],
},
{
  name: 'Budgett',
  description: 'A self-hosted, full-stack budget app using Node.js, express.js, & React that automatically imports transactions via Plaid, with auto-categorization rules, formula-based budgets, and a customizable dashboard',
  icon: 'https://github.com/derekantrican/Budgett/blob/master/client/public/logo512.png?raw=true',
  website: 'https://derekantrican.com/Budgett',
  github: 'https://github.com/derekantrican/Budgett',
  type: 'Website',
  languages: [
    'Javascript',
  ],
  technologies: [
    'Node.js',
    'React',
  ],
},
{
  name: 'YTSubs.app',
  description: "A simple, serverless API for providing easy access to a user's own YouTube subscriptions by wrapping the YouTube Data API",
  icon: 'https://static.ytsubs.app/logo.png',
  website: 'https://ytsubs.app',
  github: 'https://github.com/derekantrican/ytsubs',
  type: 'Website',
  languages: [
    'Python',
  ],
  technologies: [
    'AWS',
  ],
},
{
  name: 'Opendak.app',
  description: "An open-source alternative to DAKboard, providing a customizable dashboard for displaying information like calendar events, weather, news, etc",
  icon: 'https://i.imgur.com/NNQBcrG.jpeg',
  website: 'https://opendak.app',
  github: 'https://github.com/derekantrican/opendak',
  type: 'Website',
  languages: [
    'Javascript',
  ],
  technologies: [
    'React',
  ],
},
{
  name: 'Readdit',
  description: "An open-source, read-only reddit browser built with React, designed for quickly browsing reddit without the distractions of ads, tracking, and other non-reddit content",
  icon: 'https://github.com/derekantrican/readdit/blob/master/public/logo256.png?raw=true',
  website: 'https://readdit.app',
  github: 'https://github.com/derekantrican/readdit',
  type: 'Website',
  languages: [
    'Javascript',
  ],
  technologies: [
    'React',
  ],
},
{
  name: 'ClockworkFramework',
  description: "An automation framework for running individual tasks on their own intervals, written in C#",
  icon: 'https://i.imgur.com/A9NUVZL.png',
  github: 'https://github.com/derekantrican/ClockworkFramework',
  type: 'Framework',
  languages: [
    'C#',
  ],
  technologies: [
    'Visual Studio',
  ],
},
{
  name: 'OctoPrint-Webhooks',
  description: "An OctoPrint plugin that makes 3D printer events call custom webhooks, enabling integration with services like Discord, Home Assistant, and more",
  icon: 'https://octoprint.org/assets/img/logo.png',
  github: 'https://github.com/derekantrican/OctoPrint-Webhooks',
  type: 'Plugin',
  languages: [
    'Python',
  ],
  technologies: [],
}];